/** CRM */
import React from 'react';

class CRM extends React.Component
{
    render()
    {
        return <div></div>
    }
}
export default CRM